import { useState } from "react";
import * as authApi from "../../api/auth";
import { EMAIL_RE } from "../../auth-validation";
import { AuthCard } from "./AuthCard";

/** Asks the server to email a reset link. The answer is the same whether or not the address has an account. */
export function ForgotPasswordScreen() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!EMAIL_RE.test(email.trim())) { setError("Enter the email address of your account."); return; }
    setBusy(true);
    setError("");
    try {
      await authApi.forgotPassword(email.trim());
      setSent(true);
    } catch (e) {
      setError((e as Error).message);
    } finally { setBusy(false); }
  };

  return (
    <AuthCard>
      <h1>Forgot password</h1>
      {sent ? (
        <div className="sub" data-testid="forgot-sent">
          If an account uses that address, an email with a reset link is on its way. The link works once and expires in an hour.
        </div>
      ) : (
        <>
          <div className="sub">Enter your email address and we will send you a link to choose a new password.</div>
          <label className="caption" htmlFor="fp-email">Email</label>
          <input id="fp-email" className="input" placeholder="your@email.com" autoComplete="email" value={email} autoFocus
            onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") void submit(); }} />
          <div className="error-text" role="alert" data-testid="forgot-error">{error}</div>
          <button className="btn primary" disabled={busy} onClick={submit} data-testid="forgot-submit">Send reset link</button>
        </>
      )}
      <div className="switch"><a className="btn flat" href="#/login" data-testid="to-login">Back to sign in</a></div>
    </AuthCard>
  );
}
